import React from "react";

export const marketingTable = (handleEdit, handleDelete) => {
  return [
    {
      title: "Id Marketing",
      render: (rowData) => {
        return <span>{rowData.id_marketing}</span>;
      },
    },
    {
      title: "Nama Marketing",
      render: (rowData) => {
        return <span>{rowData.nama_marketing}</span>;
      },
    },
    {
      title: "Nomor HP",
      render: (rowData) => {
        return <span>{rowData.no_hp_marketing}</span>;
      },
    },
    {
      title: "Created By",
      render: (rowData) => {
        return <span>{rowData.created_by}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Updated At",
      render: (rowData) => {
        return <span>{rowData.updated_at}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
          </>
        );
      },
    },
  ];
};
